import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineAdjustmentsVertical } from 'react-icons/hi2';
import { ActionIcon, Button, Group, Stack } from '@mantine/core';

import { ALL, dispatchStatuses } from 'constants/dispatch';

import { DispatchFilter as DispatchFilterType, DispatchStateType } from 'store/dispatch/types';
import { Typeahead } from 'common/Components/Mantine/Typeahead';

type DispatchFiltersPropsType = {
  dispatch: DispatchStateType | undefined;
  filter: DispatchFilterType;
  onValueChange: (
    key: keyof DispatchFilterType,
    value: string | boolean | undefined | null,
  ) => void;
};

export const DispatchFilters = ({ dispatch, filter, onValueChange }: DispatchFiltersPropsType) => {
  const { t } = useTranslation();

  const handleStatusFilter = (value: string) => {
    onValueChange('dispatch_status', value === ALL ? undefined : value);
  };

  const handleAlertFilter = (value: string) => {
    onValueChange('alert_name', filter.alert_name === value ? undefined : value);
  };

  const filterStatus = filter.dispatch_status || ALL;
  return (
    <Stack>
      <Group justify="space-between">
        <Typeahead
          onSelect={() => {}}
          data={[]} // Replace with user/operation/agency search
        />
        <ActionIcon variant="subtle" radius="xl" size="xl" disabled>
          <HiOutlineAdjustmentsVertical size="2rem" />
        </ActionIcon>
      </Group>
      {dispatch && (
        <Stack>
          <Button.Group>
            {dispatchStatuses.map((status) => (
              <Button
                key={status}
                variant={status === filterStatus ? 'filled' : 'unselected'}
                onClick={() => handleStatusFilter(status)}
              >
                {`${t(status)} (${dispatch.counts[status].count.toLocaleString()})`}
              </Button>
            ))}
          </Button.Group>
          <Group>
            {Object.entries(dispatch.counts[filterStatus].alerts || []).map(([alert, count]) => (
              <Button
                key={alert}
                variant={alert === filter.alert_name ? 'filled' : 'unselected'}
                onClick={() => handleAlertFilter(alert)}
              >
                {`${t(alert)} (${count.toLocaleString()})`}
              </Button>
            ))}
          </Group>
        </Stack>
      )}
    </Stack>
  );
};
